import { render, staticRenderFns } from "./AutoCompletePractitioners.vue?vue&type=template&id=084107b7&"
import script from "./AutoCompletePractitioners.vue?vue&type=script&lang=js&"
export * from "./AutoCompletePractitioners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports